import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "This store is disabled or you are not store/support admin user", -1)

import { useAuth0 } from "@auth0/auth0-vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'StoreDisable',
  setup(__props) {


const auth0 = useAuth0();
function logout() {
  sessionStorage.removeItem('vuex');
  localStorage.clear();
  auth0.logout({
    returnTo: window.location.origin
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", null, [
        _createTextVNode(" Please "),
        _createElementVNode("a", {
          id: "qsLogoutBtn",
          href: "#",
          class: "",
          onClick: _withModifiers(logout, ["prevent"])
        }, "Log out"),
        _createTextVNode(" and then contact superadmin for help. ")
      ])
    ])
  ]))
}
}

})